import {axios} from '@js/utilities/axios.js';

const defaultValues = {
	id: null,
	title: null,
	first_name: null,
	last_name: null,
	dob: null,
	gender: null,
	k_number: null,
	email: null,
	address: null,
	suburb: null,
	state: null,
	post_code: null,
	country: null,
	timezone: null,
	phone: '',
	landline: '',
	emergency_contact_phone: '',
	start_date: null,
	abn: null,
	bsb: null,
	bank_number: null,
	type: 'User',
	is_registered_for_gst: 0,
	status: 'Active',
	ndis_id: null,
	no_email_available: 0,
	area_managers: [],
	onboarding_status: {},
}

export default {
	namespaced: true,
	state: {
		selected_user: defaultValues,
		show_profile: false,
		lock: {},
		lockInterval: null,
	},
	actions: {
		setUser(context, id) {
			return new Promise((resolve) => {
				context.state.selected_user = defaultValues;
				context.state.selected_user.id = id;

				context.dispatch('unlock').then(() => {
					if (!id) {
						resolve();

						return;
					}

					context.dispatch('lock', id).then(() => {
						context.dispatch('fetchUser', id).then(() => {
							resolve();
						});
					})
				});
			})
		},
		fetchUser(context, id) {
			return new Promise((resolve, reject) => {
				axios.get('/api/users/' + id).then((response) => {
					let user = response.data.data;
					user.phone = user.phone ? user.phone : '';
					user.landline = user.landline ? user.landline : '';
					user.emergency_contact_phone = user.emergency_contact_phone ? user.emergency_contact_phone : '';

					context.commit('setSelectedUser', response.data.data);
					resolve(response);
				}).catch((error) => {
					alert('Something went wrong.');
					reject(error);
				});
			});
		},
		lock(context, id) {
			return new Promise((resolve, reject) => {
				axios.post(`/api/users/${id}/lock`).then(response => {
					context.commit('setLock', response.data);
					resolve(response);
				}).catch(error => {
					reject(error);
				}).finally(() => {
					this.lockInterval = window.setTimeout(() => {
						context.dispatch('lock', id);
					}, 20000)
				})
			})
		},
		unlock(context) {
			if (!context.state.lock.id) {
				return
			}

			const existingLock = context.state.lock;
			context.commit('setLock', {});

			return new Promise((resolve, reject) => {
				axios.post(`/api/users/${existingLock.id}/unlock`).then(response => {
					context.commit('setLock', {});
					clearInterval(this.lockInterval);
					resolve(response);
				}).catch(error => {
					context.commit('setLock', existingLock);
					reject(error);
				});
			})
		},
		refresh(context) {
			return context.dispatch('fetchUser', context.state.selected_user.id)
		},
		resetOnboarding(context) {
			return new Promise((resolve, reject) => {
				axios.post('/api/users/' + context.state.selected_user.id + '/reset-onboarding').then((response) => {
					resolve(response);
				}).catch((error) => {
					reject(error);
				});
			})
		},
		deleteUser(context) {
			return new Promise((resolve, reject) => {
				axios.delete('/api/users/' + context.state.selected_user.id).then((response) => {
					resolve(response);
				}).catch((error) => {
					reject(error);
				});
			})
		},
		saveSettings(context) {
			return new Promise((resolve, reject) => {
				let payload = {
					opted_out_of_automatic_smses: context.state.selected_user.opted_out_of_automatic_smses,
					service_confirmations_enabled: context.state.selected_user.service_confirmations_enabled,
					is_payment_receipt_enabled: context.state.selected_user.is_payment_receipt_enabled,
					checkin_checkout: context.state.selected_user.checkin_checkout,
					can_do_oneoff_jobs: context.state.selected_user.can_do_oneoff_jobs,
					can_do_regular_jobs: context.state.selected_user.can_do_regular_jobs,
					can_do_window_cleaning: context.state.selected_user.can_do_window_cleaning,
					accepts_invoice_jobs: context.state.selected_user.accepts_invoice_jobs,
					insurance_levy_amount: context.state.selected_user.insurance_levy_amount,
					wont_use_app: context.state.selected_user.wont_use_app,
					job_preferences: context.state.selected_user.job_preferences,
					job_approval_required: context.state.selected_user.job_approval_required ? 1 : 0,

				}

				if (context.state.selected_user.blacklisted_cleaners && context.state.selected_user.is_client) {
					payload.blacklisted_cleaners = context.state.selected_user.blacklisted_cleaners.map(u => u.id)
				}

				axios.put('/api/users/' + context.state.selected_user.id + '/settings', payload).then((response) => {
					resolve(response);
				}).catch((error) => {
					reject(error);
				});
			})
		},
		updateUser(context) {
			let user = {...context.state.selected_user}
			return axios.put(`/api/users/${user.id}`, user);
		},
		createUser(context) {
			let user = {...context.state.selected_user}
			return axios.post('/api/users', user);
		},
		resetSelectedUser(context) {
			let defaults = {
				id: null,
				title: null,
				first_name: null,
				last_name: null,
				dob: null,
				gender: null,
				k_number: null,
				email: null,
				address: null,
				suburb: null,
				state: null,
				post_code: null,
				country: null,
				timezone: null,
				phone: '',
				landline: '',
				emergency_contact_phone: '',
				start_date: null,
				abn: null,
				bsb: null,
				bank_number: null,
				type: 'User',
				is_registered_for_gst: 0,
				status: 'Active',
				ndis_id: null,
				no_email_available: 0,
				area_managers: [],
			}

			context.state.selected_user = defaults;
		}
	},
	mutations: {
		setSelectedUser(state, user) {
			state.selected_user = user;
		},
		setLock(state, lock) {
			state.lock = lock;
		},
	},
	getters: {
		getSelectedUser(state) {
			return state.selected_user;
		},
		getLock(state) {
			return state.lock;
		},
		isCleaner(state) {
			return state.selected_user.is_cleaner;
		},
		isClient(state) {
			return state.selected_user.is_client;
		},
		isLocked(state) {
			if (!state.lock.id) {
				return false
			}

			return !state.lock.obtained;
		}
	}
}
